<template>
  <div class="advertisement_list">
    <div class="">
      <div
        style="display: flex"
        v-if="!popList[tabIndex].content"
        @click="openUrl(popList[tabIndex])"
      >
        <img
          src=""
          class="_common-tabs-content"
          v-lazy="popList[tabIndex].image"
          alt=""
        />
      </div>
      <!-- tabIndex -->
      <div v-else class="_common-tabs-content" style="overflow: scroll">
        <div class="title">{{ popList[tabIndex].title }}</div>
        <div
          style="font-size: 0.23rem; margin: 0 0.1rem 0 0.1rem"
          v-html="popList[tabIndex].content"
        ></div>
      </div>
      <div
        style="
          padding: 0.3rem;
          display: flex;
          overflow-x: scroll;
          align-items: center;
        "
      >
        <div
          class="consliTst"
          :class="{
            'common-tab-item-active': tabIndex == index
          }"
          v-for="(item, index) in popList"
          @click="tabIndex = index"
        >
          <svg-icon
            className="imageWrap"
            icon-class="icon_message_pmd--svgSprite:all"
          />
          <span>{{ item.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { userInfo } from '@/apis/modules/home.js';
export default {
  props: {
    popList: {
      type: [Object, Array],
      required: []
    }
  },
  data() {
    return {
      codeValue: '',
      inputFocus: false,
      tabIndex: 0,
      rememberPassword: window.localStorage.getItem('rememberPassword')
    };
  },
  computed: {
    ...mapState(['vuex_token_head','userInfo'])
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      if(this.$store.state.config.goto_bind_ws && this.userInfo.id && !this.userInfo.bind_ws && this.$store.state.config.bind_ws){
        userInfo({}).then(({ data,code }) => {
          if(code == 0){
            this.$store.state.config.goto_bind_ws = false;
            this.$store.commit('userInfo', data);
          }
        });
      }
    },
    openUrl(e) {
      if (e.jump_url && e.jump_url != '#') {
        if (/^http/.test(e.jump_url)) {
          window.open(e.jump_url, '_blank');
          return false;
        }
        if (e.jump_url == 'dailySignIn') {
          this.$store.commit('publicFun', ['CancelIsSigned_days', true]);
          return false;
        }
        if (e.jump_url == 'pdd') {
          this.$store.state.isShowWheelSpinEvent = true;
          return false;
        }else if (e.jump_url == 'recharge') {
          if (!this.vuex_token_head) {
            if (this.rememberPassword && this.rememberPassword.length) {
              this.$store.commit('isRecord');
              this.$store.commit('publicFun', ['isRecordType', 1]);
            } else {
              this.$store.commit('isRecord');
              this.$store.commit('publicFun', ['isRecordType', 0]);
            }
            return false;
          }
          this.$store.commit('isDeposit', true);
          return false;
        }else if (e.jump_url == '#register') {
          if (!this.vuex_token_head) {
            if (this.rememberPassword && this.rememberPassword.length) {
              this.$store.commit('isRecord');
              this.$store.commit('publicFun', ['isRecordType', 1]);
            } else {
              this.$store.commit('isRecord');
              this.$store.commit('publicFun', ['isRecordType', 0]);
            }
            return false;
          }
          return false;
        }else if (e.jump_url == '#BINDWS#') {
          let uid = '';
          if (this.vuex_token_head) {
            // 判断是否已经绑定
            if(this.userInfo.bind_ws)return false;
            uid = this.userInfo.id
          }
          this.$store.state.config.goto_bind_ws = true;
          this.$router.push({
            name: 'webviewCommon',
            params: {
              url: this.$store.state.config.bind_ws+'/'+window.location.hostname+'/'+uid
            }
          });
          return false;
        }
        this.$router.push({ name: e.jump_url });
      }
    }
  }
};
</script>
<style>
.login-body {
  font-weight: 400;
}
.van-popup.advertisement_-conter {
  background-color: transparent;
}
</style>
<style scoped>
.common-tab-item-active {
  background-color: rgba(var(--theme-primay-color-hex), 0.05);
}
.advertisement_list {
  width: 6.9rem;
  background-color: var(--theme-main-bg-color);
  border-radius: 0.2rem;
}
.advertisement_list .title {
  color: var(--theme-text-color-darken);
  text-align: center;
  line-height: 1rem;
  font-size: 0.4rem;
}
._common-tabs-content {
  max-height: 5.4rem;
  width: 100%;
}
.consliTst {
  display: flex;
  align-items: center;
  border-radius: 0.1rem;
  margin-right: 0.1rem;
  height: 0.8rem !important;
  /* background-color: rgba(var(--theme-primay-color-hex), .05); */
  max-width: 2.05rem;
  padding: 0.15rem;
  text-align: revert !important;
}
.consliTst svg {
  width: 0.38rem;
  height: 0.38rem;
  color: var(--theme-primary-color);
  margin-right: 0.08rem;
}
.consliTst span {
  font-size: 0.22rem;
  display: inline-block;
  line-height: 0.28rem;
  flex: 1;
  color: var(--theme-primary-color);
  overflow: hidden;
  text-overflow: ellipsis;
  /* white-space: nowrap; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  white-space: break-spaces !important;
}
</style>
